import { ValiError } from 'valibot';

import { API } from '@/api';
import { fetcher, HTTPError, logger } from '@/services/fetcher';

import { shipmentDefaultAddressListApiSchema } from '../../models';
import type { ShipmentType } from '../../types';

const shipmentApi = fetcher.extend(() => ({ prefixUrl: `${API.SHIPMENT}` }));

export type GetShipmentDefaultAddressRequestParams = {
  branchKey: number;
  shipmentTypeValue: ShipmentType;
};

export const fetchShipmentDefaultAddress = async (
  filters: GetShipmentDefaultAddressRequestParams,
  { signal }: { signal?: AbortController['signal'] } = {},
) => {
  try {
    return await shipmentApi
      .get('GetShipmentTypeDefaultAddress', { searchParams: filters, signal })
      .json(shipmentDefaultAddressListApiSchema);
  } catch (error) {
    if (error instanceof ValiError || (error instanceof Error && error.name === 'ValiError')) {
      logger.warn(
        'Validation error on ShipmentDefaultAddress response',
        (error as ValiError<typeof shipmentDefaultAddressListApiSchema>).issues,
      );
    }
    if (error instanceof HTTPError) {
      logger.error(`Error: ${error.response.status}`);
    }
    throw error;
  }
};
